import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from '@surfline/quiver-react';
import en from '../../../international/translations/en';
import { reduxForm } from 'redux-form';
import passwordValidation from './passwordValidation';
import brandToString from '../../../utils/brandToString';

class PasswordForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitFunc: PropTypes.func.isRequired,
    initializeForm: PropTypes.func.isRequired,
    error: PropTypes.string,
    userEmail: PropTypes.string,
    formLocation: PropTypes.string,
    submitting: PropTypes.bool,
  };

  componentWillMount() {
    this.props.initializeForm({
      email: this.props.userEmail,
    });
  }

  keepAccount() {
    const goToSubscription = () =>
      (window.location.href = '/account/subscription');
    if (window.analytics) {
      window.analytics.track('Kept Account', {
        location: 'cancel-funnel-verification',
      });
      window.setTimeout(goToSubscription, 500);
    } else {
      goToSubscription();
    }
  }

  render() {
    const {
      fields: { password },
      handleSubmit,
      submitFunc,
      submitting,
    } = this.props;

    let passwordError = 'loginForm__error__text__hidden';
    if (password.error && password.touched) {
      if (password.error === ' ') {
        passwordError = 'loginForm__error__no__text';
      } else {
        passwordError = 'loginForm__error__text';
      }
    }

    let passwordErrorInput = '';
    if (password.error && password.touched) {
      passwordErrorInput = 'loginForm__input__hasError';
    } else if (password.touched) {
      passwordErrorInput = 'loginForm__input__isValid';
    }

    return (
      <form onSubmit={handleSubmit(submitFunc)} className="loginForm">
        <div className="loginForm__input__password">
          <input
            type="password"
            id="password"
            {...password}
            className={passwordErrorInput}
            required
          />
          <label
            htmlFor="password"
            className="loginForm__label__floating"
          >
            {en.sign_in.form.label_password}
          </label>
          <div className={passwordError}>{password.error}</div>
        </div>
        <a className="loginForm__forgotPassword" href="/forgot-password">
          {en.sign_in.form.forgot_password}
        </a>
        <div className="buttonBar">
          <Button loading={submitting}>
            {en.cancellation_funnel.action_password_continue}
          </Button>
          <button
            type="button"
            onClick={this.keepAccount}
            className="branded"
          >
            {en.cancellation_funnel.action_password_keep_account(brandToString())}
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'verifyPassword',
  fields: ['password', 'email'],
  validate: passwordValidation,
})(PasswordForm);
